import moment from 'moment';
import * as actionType from 'actions';
import secureStorage from 'utils/secureStorage';

const initialState = {
    isApplicantAdded: false,
    isLoggedIn: false,
    isLoading: false,
    applicantGuid: '',
    email: '',
    loginStatusMessage: '',
    errorMessage: '',
    errorStatus: false,
    jobDetails: {},
    isNotValidPath: false,
    isRegistered: false,
    registerStatusMessage: '',
    isLinkSent: false,
    forgotPassStatusMessage: '',
    isResetLoading: false,
    isReset: false,
    resetPassStatusMessage: '',
    isLoginLoading: false,
    isRegisterLoading: false,
    registerDetails: {},
    loginDetails: {},
    isLogout: false,
    publicToken: '',
    appStartDate: '',
    isValidationRequired: false,
    resendSignUpDetails: {},
    isUserAlreadyExists: false,
    isPasswordUpdateLoading: false,
    passwordChangeStatusMessage: '',
    jobApplications: [],
    jobUrlApplication: {},
    isJobApplicationsLoading: false,
    jobUrlLink: '',
    viewSubmittedJobApplicationPdf: {},
    isViewSubmittedJobApplicationPdfLoading: false,
};

const auth = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_JOB_DETAILS: {
            return {
                ...state,
                isLoading: true,
            };
        }

        case actionType.GET_JOB_DETAILS_SUCCESS: {
            secureStorage.setItem("jobOpeningGuid", action.payload.jobOpeningGuid);
            secureStorage.setItem("jobOpeningUrlGuid", action.payload.jobOpeningUrlGuid);
            secureStorage.setItem("jobUrlCountryCode", action.payload.countryId);
            const jobUrlParam = secureStorage.getItem('jobUrlParam');
            const clientSuffix = jobUrlParam?.ClientSuffix;
            const jobCode = jobUrlParam?.JobCode;
            const currentHref = window?.location?.href || '';
            return {
                ...state,
                isLoading: false,
                jobDetails: { jobUrlLink: (clientSuffix && jobCode && currentHref.includes(clientSuffix) && currentHref.includes(jobCode)) ? currentHref : state?.jobUrlLink, ...action.payload },
                isNotValidPath: action.payload.companyName == null ? true : false,
            };
        }

        case actionType.AUTH_LOGIN_POST: {
            secureStorage.setItem("user_email", action.payload.userName);

            return {
                ...state,
                isLoginLoading: true,
            };
        }

        case actionType.AUTH_LOGIN_POST_SUCCESS: {
            secureStorage.setItem("auth_status", !!action.payload);
            secureStorage.setItem("applicantGuid", action.payload?.username);

            return {
                ...state,
                isLoggedIn: !!action.payload,
                applicantGuid: action.payload?.username,
                email: (action.payload?.attributes?.email !== undefined ? action.payload?.attributes?.email : ''),
                loginDetails: action.payload,
                isLoginLoading: false,
                jobUrlLink: window?.location?.href
            };
        }

        case actionType.AUTH_LOGOUT_POST: {
            return {
                ...state,
            };
        }

        case actionType.AUTH_LOGOUT_POST_SUCCESS: {
            return {
                ...state,
                isLogout: true,
            };
        }

        case actionType.AUTH_REGISTER_POST: {
            secureStorage.setItem("user_email", action.payload.username);

            return {
                ...state,
                isRegisterLoading: true,
            };
        }

        case actionType.AUTH_REGISTER_POST_SUCCESS: {
            if (action.payload !== undefined && action.payload.code === "UsernameExistsException") {
                return {
                    ...state,
                    isRegisterLoading: false,
                    errorStatus: false,
                    isRegistered: true,
                };
            }

            if (action.payload !== undefined && action.payload.authenticationFlowType === "USER_SRP_AUTH") {
                secureStorage.setItem("auth_status", true);

                return {
                    ...state,
                    isRegisterLoading: false,
                    isRegistered: true
                };
            }
            else {
                secureStorage.setItem("auth_status", action.payload.status);
                secureStorage.setItem("applicantGuid", action.payload.applicantGuid);

                return {
                    ...state,
                    isRegistered: action.payload.status,
                    isLoggedIn: action.payload.status,
                    applicantGuid: action.payload.applicantGuid,
                    registerStatusMessage: action.payload.message,
                    registerDetails: action.payload,
                    isRegisterLoading: false,
                };
            }
        }

        case actionType.AUTH_FORGOT_PASSWORD_VALIDATION_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                forgotPasswordComplete: true
            }
        }

        case actionType.AUTH_FORGOT_PASSWORD_POST: {
            return {
                ...state,
                isLoading: true,
            };
        }

        case actionType.AUTH_FORGOT_PASSWORD_POST_SUCCESS: {
            return {
                ...state,
                isLinkSent: action.payload,
                forgotPassStatusMessage: action.payload,
                isLoading: false,
            };
        }

        case actionType.AUTH_RESET_PASSWORD: {
            return {
                ...state,
                isResetLoading: true,
            };
        }

        case actionType.AUTH_RESET_PASSWORD_SUCCESS: {
            return {
                ...state,
                isReset: action.payload.status,
                resetPassStatusMessage: action.payload.statusMessage,
                isResetLoading: false,
            };
        }

        case actionType.ADD_APPLICANT: {
            return {
                ...state,
                isLoading: true,
            };
        }

        case actionType.ADD_APPLICANT_SUCCESS: {
            return {
                ...state,
                isApplicantAdded: action.payload.status,
                isLoading: false,
            };
        }

        case actionType.AUTH_RESEND_SIGN_UP_POST: {
            return {
                ...state,
            };
        }

        case actionType.AUTH_RESEND_SIGN_UP_SUCCESS: {
            return {
                ...state,
                resendSignUpDetails: action.payload,
            };
        }

        case actionType.AUTH_RESEND_SIGN_UP_FAILED: {
            return {
                ...state,
                resendSignUpDetails: { ...action.payload, 'isError': true },
            };
        }

        case actionType.RESET_RESEND_SIGN_UP: {
            return {
                ...state,
                resendSignUpDetails: {},
                isRegistered: false,
            };
        }

        case actionType.RESET_USER_ALREADY_EXISTS: {
            return {
                ...state,
                isUserAlreadyExists: false,
            };
        }

        case actionType.GET_ALL_APPLICATIONS_FOR_APPLICANT_POST: {
            return {
                ...state,
                jobApplications: [],
                jobUrlApplication: {},
                isJobApplicationsLoading: true,
            }
        }

        case actionType.GET_ALL_APPLICATIONS_FOR_APPLICANT_SUCCESS: {
            const jobApplications = action.payload?.applications || [];
            const sortedJobApplications = [];

            if(jobApplications?.length > 0) {
                jobApplications?.sort(
                    (a, b) => a?.positionTitle.localeCompare(b.positionTitle)
                )

            const applicationParentGUIDs = jobApplications?.map((application) => application?.applicationParentGUID);
            const uniqueApplicationParentGUIDs = [...new Set(applicationParentGUIDs)];
            const date = moment().subtract('6', 'month').format('YYYY-MM-DD');

            uniqueApplicationParentGUIDs?.map((parentGUID) => {
                let applications =  jobApplications?.filter((application) => application?.applicationParentGUID === parentGUID);
                let {jobApplicationGuid, applicationParentGUID, ...jobApplicationDetails } = applications?.[0] || {};

                if (applications.length > 0) {
                    const continueApplications = applications?.filter(application => application?.submittedDate === null);
                    const submittedApplications = applications?.filter(application => application?.submittedDate !== null);
                    
                    submittedApplications.sort(
                        (a, b) => new Date(b?.submittedDate) - new Date(a?.submittedDate)
                    );

                    applications = [...continueApplications, ...submittedApplications];
                }

                sortedJobApplications.push({
                    ...jobApplicationDetails,
                    applicationParentGuid: parentGUID,
                    applications: applications,
                    submittedDate: applications?.findLast(application => application?.submittedDate !== null)?.submittedDate ?? '',
                    viewApplicationGuid : applications?.find(application => application?.submittedDate !== null)?.jobApplicationGuid ?? '',
                    editApplicationGuid : jobApplicationDetails?.submittedDate && moment(moment(jobApplicationDetails?.submittedDate).format('YYYY-MM-DD')).isAfter(date)? jobApplicationGuid : '',
                    continueApplicationGuid : jobApplicationDetails?.submittedDate  ? '' : jobApplicationGuid,
                    lastEditedDate: jobApplicationDetails?.submittedDate ?? '',
                });
            })
        }
            const matchingApplications = (action.payload?.applications || [])
                .filter(app => state?.jobDetails?.jobUrlLink?.includes(app?.url));

            const latestMatchingApplication = matchingApplications?.length > 0
                ? [...matchingApplications].sort(
                    (a, b) => new Date(b?.lastEditedDate || 0) - new Date(a?.lastEditedDate || 0)
                  )[0]
                : null;

            const sixMonthsAgo = moment().subtract('6', 'month').format('YYYY-MM-DD');

            const jobUrlApplication = latestMatchingApplication
                ? {
                    ...latestMatchingApplication,
                    applicationParentGuid: latestMatchingApplication?.applicationParentGUID,
                    continueApplicationGuid: latestMatchingApplication?.submittedDate ? '' : latestMatchingApplication?.jobApplicationGuid,
                    editApplicationGuid: latestMatchingApplication?.submittedDate && moment(moment(latestMatchingApplication?.submittedDate).format('YYYY-MM-DD')).isAfter(sixMonthsAgo) ? latestMatchingApplication?.jobApplicationGuid : '',
                }
                : {};

            return {
                ...state,
                isJobApplicationsLoading: false,
                jobApplications: sortedJobApplications,
                jobUrlApplication,
            }
        }

        case actionType.VIEW_SUBMITTED_JOB_APPLICATION_PDF_POST:{
            return {
                ...state,
                viewSubmittedJobApplicationPdf: {},
                isViewSubmittedJobApplicationPdfLoading: true,
            }
        }

        case actionType.VIEW_SUBMITTED_JOB_APPLICATION_PDF_SUCCESS:{
            return {
                ...state,
                viewSubmittedJobApplicationPdf: action.payload,
                isViewSubmittedJobApplicationPdfLoading: false,
            }
        }

        case actionType.COMMON_ERROR: {
            return {
                ...state,
                errorMessage: action.payload.error,
                errorStatus: true,
                isLoggedIn: false,
                isLoading: false,
                isNotValidPath: false,
                isRegistered: false,
                isLinkSent: false,
                isResetLoading: false,
                isReset: false,
                isLoginLoading: false,
                isRegisterLoading: false,
                isLogout: false,
                isPasswordUpdateLoading: false,
            }
        }

        case actionType.COMMON_ERROR_CLOSE: {
            return {
                ...state,
                errorStatus: false
            }
        }
        default: {
            return state;
        }

        case actionType.ADD_REGISTERED_USER: {
            return {
                ...state,
                isLoading: true,
            };
        }

        case actionType.ADD_REGISTERED_USER_SUCCESS: {
            return {
                ...state,
                isLoading: false,
            };
        }

        case actionType.GET_HEADERDETAILS_SUCCESS: {
            return {
                ...state,
                publicToken: action.payload.publictoken,
                appStartDate: action.payload.apistartdate,
            }
        }

        case actionType.AUTH_PASSWORD_UPDATE_POST: {
            return {
                ...state,
                isPasswordUpdateLoading: true,
                passwordChangeStatusMessage: '',
            };
        }

        case actionType.AUTH_PASSWORD_UPDATE_POST_SUCCESS: {
            return {
                ...state,
                passwordChangeStatusMessage: action.payload,
                isPasswordUpdateLoading: false,
            };
        }

        case actionType.AUTH_PASSWORD_UPDATE_POST_FAILED: {
            return {
                ...state,
                passwordChangeStatusMessage: action.payload,
                isPasswordUpdateLoading: false,
            };
        }
    }
};

export default auth;